import React from 'react';

import { Scenario } from '@/types';
import { useViewMode } from '../../hooks/useViewMode';
import { DevelopmentFlag } from '../../helpers/DevelopmentFlag';

export type OptimizeScenarioButtonProps = {
  scenarioId: string;
  scenario: Scenario;
  isUpdating: boolean;
  shouldLiveUpdate: boolean;
  disabled: boolean;
  toggleLiveUpdate: React.ChangeEventHandler<HTMLInputElement>;
  onClick: (update: boolean) => void;
};

export const OptimizeScenarioButton: React.FC<OptimizeScenarioButtonProps> = ({
  scenario,
  isUpdating,
  shouldLiveUpdate,
  disabled,
  toggleLiveUpdate,
  onClick,
}) => {
  const [viewMode] = useViewMode();
  return (
    <div className="btn-group w-100">
      {scenario.readonly !== true && viewMode === 'development' && (
        <button
          className="btn btn-primary form-control"
          disabled={isUpdating || disabled}
          onClick={() => onClick(false)}
          id="optimize-scenario"
        >
          <DevelopmentFlag className="me-1" />{' '}
          {isUpdating ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Optimizing...
            </>
          ) : (
            <>Optimize</>
          )}
        </button>
      )}
      {/* <button
        className="btn btn-primary form-control"
        disabled={isUpdating || disabled}
        onClick={() => navigate(`/scenarios/${scenario.id}/all-paths`)}
      >
        Pick Paths
      </button> */}
      {viewMode === 'development' && (
        <button
          className="btn btn-primary form-control"
          disabled={isUpdating || disabled}
          onClick={() => onClick(true)}
          id="refresh-and-optimize-scenario"
          aria-label="Optimize"
        >
          <DevelopmentFlag className="mx-2" />
          {isUpdating ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Optimizing...
            </>
          ) : (
            <>Refresh and Optimize</>
          )}
        </button>
      )}
      {viewMode === 'development' && (
        <div className="btn btn-default bg-light text-primary border border-primary align-items-center">
          <DevelopmentFlag className="mx-2" /> <br />
          Live Updates
          <div className="form-switch">
            <input
              disabled={isUpdating || disabled}
              onChange={toggleLiveUpdate}
              className="form-check-input"
              type="checkbox"
              id="live-update-toggle"
              checked={shouldLiveUpdate}
            />
          </div>
        </div>
      )}
    </div>
  );
};
